module.exports = ".code-header {\n  font-size: 14px;\n  font-weight: 700; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/2fa/modals/two-fa-setup-modal/enter-code/enter-code.component.scss
// module id = ./web/modern/components/2fa/modals/two-fa-setup-modal/enter-code/enter-code.component.scss
// module chunks = 0